<section class="signup-section">
  <div class="signup-wrapper">
    <div class="signup-form-container">
      <!-- Form Header -->
      <div class="form-header">
        <h1 class="form-title">{{ "page.registration.title" | translate }}</h1>
        <p class="form-subtitle">{{ "page.registration.subtitle" | translate }}</p>
      </div>

      <!-- Signup Form -->
      <form [formGroup]="userForm" (ngSubmit)="onSave()" class="signup-form">
        <div class="form-row">
          <!-- First Name -->
          <div class="form-group">
            <label for="firstname" class="form-label">{{ "form.firstname" | translate }}*</label>
            <input type="text" id="firstname" formControlName="firstname" class="form-input" maxlength="22" />
            <div class="error-message" *ngIf="userForm.controls.firstname.touched && userForm.controls.firstname.errors?.['required']">
              <span>{{ "page.login.error.required" | translate }} </span>
            </div>
          </div>
          <!-- Last Name -->
          <div class="form-group">
            <label for="name" class="form-label">{{ "form.name" | translate }}*</label>
            <input type="text" id="name" formControlName="name" class="form-input" maxlength="23" />
            <div class="error-message" *ngIf="userForm.controls.name.touched && userForm.controls.name.errors?.['required']">
              <span>{{ "page.login.error.required" | translate }} </span>
            </div>
          </div>
        </div>
        <div class="form-row">
          <!-- Sex -->
          <div class="form-group">
            <label for="sex" class="form-label">{{ "form.sex.title" | translate }}*</label>
            <select id="sex" formControlName="sex" class="form-input">
              <option value="FEMALE">{{ "form.sex.female" | translate }}</option>
              <option value="MALE">{{ "form.sex.male" | translate }}</option>
            </select>
            <div class="error-message" *ngIf="userForm.controls.sex.touched && userForm.controls.sex.errors?.['required']">
              <span>{{ "page.login.error.required" | translate }} </span>
            </div>
          </div>
          <!-- Birthdate -->
          <div class="form-group">
            <label for="birthdate" class="form-label">{{ "form.birthdate" | translate }}*</label>
            <input type="date" [max]="maxDate" id="birthdate" formControlName="birthdate" class="form-input" />
            <div class="error-message" *ngIf="userForm.controls.birthdate.touched && userForm.controls.birthdate.errors?.['required']">
              <span>{{ "page.login.error.required" | translate }} </span>
            </div>
            <div class="error-message" *ngIf="userForm.controls.birthdate.touched && userForm.controls.birthdate.errors?.['futureDate']">
              <span>{{ "page.login.error.futureDate" | translate }} </span>
            </div>
          </div>
        </div>
        <div class="form-row">
          <!-- National number -->
          <div class="form-group">
            <label for="nationalNumber" class="form-label">{{ "form.nationalNumber" | translate }}*</label>
            <input type="nationalNumber" id="nationalNumber" formControlName="nationalNumber" class="form-input" maxlength="20" />
            <div
              class="error-message"
              *ngIf="userForm.controls.nationalNumber.touched && userForm.controls.nationalNumber.errors?.['required']"
            >
              <span>{{ "page.login.error.required" | translate }} </span>
            </div>
          </div>
          <!-- Email -->
          <div class="form-group">
            <label for="email" class="form-label">{{ "form.email" | translate }}*</label>
            <input type="email" id="email" formControlName="email" class="form-input" maxlength="255" />
            <div class="error-message" *ngIf="userForm.controls.email.touched && userForm.controls.email.errors?.['required']">
              <span>{{ "page.login.error.required" | translate }} </span>
            </div>
            <div class="error-message" *ngIf="userForm.controls.email.touched && userForm.controls.email.errors?.['pattern']">
              <span>{{ "page.login.error.email" | translate }} </span>
            </div>
          </div>
        </div>
        <div class="form-row">
          <!-- Password -->
          <div class="form-group">
            <label for="password" class="form-label">{{ "form.password" | translate }}*</label>
            <div class="password-input-wrapper">
              <input
                [type]="showPassword ? 'text' : 'password'"
                id="password"
                formControlName="password"
                class="form-input"
                maxlength="255"
              />
              <button type="button" class="password-toggle" (click)="showPassword = !showPassword">
                {{ showPassword ? "👁️" : "👁️‍🗨️" }}
              </button>
            </div>
            <div class="error-message" *ngIf="userForm.controls.password.touched && userForm.controls.password.errors?.['required']">
              <span>{{ "page.login.error.required" | translate }} </span>
            </div>
            <div class="error-message" *ngIf="userForm.controls.password.touched && userForm.controls.password.errors?.['pattern']">
              <span>{{ "page.login.error.password" | translate }} </span>
            </div>
          </div>
          <!-- Confirm Password -->
          <div class="form-group">
            <label for="confirmPassword" class="form-label">{{ "form.confirmPassword" | translate }}*</label>
            <div class="password-input-wrapper">
              <input
                [type]="showConfirmPassword ? 'text' : 'password'"
                id="confirmPassword"
                formControlName="confirmPassword"
                class="form-input"
                maxlength="255"
              />
              <button type="button" class="password-toggle" (click)="showConfirmPassword = !showConfirmPassword">
                {{ showConfirmPassword ? "👁️" : "👁️‍🗨️" }}
              </button>
            </div>
            <div
              class="error-message"
              *ngIf="userForm.controls.confirmPassword.touched && userForm.controls.confirmPassword.errors?.['required']"
            >
              <span>{{ "page.login.error.required" | translate }} </span>
            </div>
            <div
              class="error-message"
              *ngIf="userForm.controls.confirmPassword.touched && userForm.controls.confirmPassword.errors?.['matching']"
            >
              <span>{{ "page.login.error.confirmPassword" | translate }} </span>
            </div>
          </div>
        </div>
        <div class="form-row">
          <!-- Street -->
          <div class="form-group">
            <label for="street" class="form-label">{{ "form.street" | translate }}*</label>
            <input type="text" id="street" formControlName="street" class="form-input" maxlength="255" />
            <div class="error-message" *ngIf="userForm.controls.street.touched && userForm.controls.street.errors?.['required']">
              <span>{{ "page.login.error.required" | translate }} </span>
            </div>
          </div>
          <!-- Number -->
          <div class="form-group">
            <label for="number" class="form-label">{{ "form.number" | translate }}*</label>
            <input type="text" id="number" formControlName="number" class="form-input" maxlength="10" />
            <div class="error-message" *ngIf="userForm.controls.number.touched && userForm.controls.number.errors?.['required']">
              <span>{{ "page.login.error.required" | translate }} </span>
            </div>
          </div>
        </div>
        <div class="form-row">
          <!-- Postal Code -->
          <div class="form-group">
            <label for="postalCode" class="form-label">{{ "form.postalCode" | translate }}*</label>
            <input type="text" id="postalCode" formControlName="postalCode" class="form-input" maxlength="10" />
            <div class="error-message" *ngIf="userForm.controls.postalCode.touched && userForm.controls.postalCode.errors?.['required']">
              <span>{{ "page.login.error.required" | translate }} </span>
            </div>
          </div>
          <!-- City -->
          <div class="form-group">
            <label for="city" class="form-label">{{ "form.city" | translate }}*</label>
            <input type="text" id="city" formControlName="city" class="form-input" maxlength="255" />
            <div class="error-message" *ngIf="userForm.controls.city.touched && userForm.controls.city.errors?.['required']">
              <span>{{ "page.login.error.required" | translate }} </span>
            </div>
          </div>
        </div>
        <div class="form-row">
          <!-- Country -->
          <div class="form-group">
            <label for="country" class="form-label">{{ "form.country" | translate }}*</label>
            <select id="country" formControlName="country" class="form-input">
              <option *ngFor="let country of countries" [ngValue]="country.code">
                {{ country.name }}
              </option>
            </select>
            <div class="error-message" *ngIf="userForm.controls.country.touched && userForm.controls.country.errors?.['required']">
              <span>{{ "page.login.error.required" | translate }} </span>
            </div>
          </div>
          <!-- Phone Number -->
          <div class="form-group">
            <label for="phone" class="form-label">{{ "form.phone" | translate }}*</label>
            <ngx-intl-tel-input formControlName="phone" id="userForm-phone"></ngx-intl-tel-input>
            <div class="error-message" *ngIf="userForm.controls.phone.touched && userForm.controls.phone.errors?.['required']">
              <span>{{ "page.login.error.required" | translate }}</span>
            </div>
            <div class="error-message" *ngIf="userForm.controls.phone.touched && userForm.controls.phone.errors?.['validatePhoneNumber']">
              <span>{{ "page.login.error.invalidPhone" | translate }}</span>
            </div>
          </div>
        </div>

        <!-- Submit -->
        <button cdkFocusInitial type="submit" class="submit-btn" [disabled]="userForm.disabled">
          {{ "button.register" | translate }}
        </button>
      </form>

      <!-- Footer -->
      <div class="form-footer">
        <p>
          {{ "page.registration.haveAccount" | translate }}
          <a routerLink="/login" routerLinkActive="active" class="link-primary">
            {{ "button.login" | translate }}
          </a>
        </p>
      </div>
    </div>
  </div>
</section>
